// API base URL - proxy handles /api routing in development
const API_BASE_URL = '/api';

// Token management
let authToken = localStorage.getItem('mm_token');

export const getToken = () => authToken;

export const setToken = (token) => {
    authToken = token;
    if (token) {
        localStorage.setItem('mm_token', token);
    } else {
        localStorage.removeItem('mm_token');
    }
};

export const clearToken = () => {
    setToken(null);
};

// Generic API request function
export const request = async (endpoint, options = {}) => {
    const url = `${API_BASE_URL}${endpoint}`;
    const headers = {
        'Content-Type': 'application/json',
        ...options.headers,
    };

    if (authToken) {
        headers.Authorization = `Bearer ${authToken}`;
    }

    const config = {
        ...options,
        headers,
    };

    if (options.body && typeof options.body === 'object') {
        config.body = JSON.stringify(options.body);
    }

    try {
        const response = await fetch(url, config);

        if (!response.ok) {
            if (response.status === 401) {
                clearToken();
                window.location.href = '/';
                throw new Error('Unauthorized');
            }

            const error = await response.json().catch(() => ({}));
            throw new Error(error.error || `HTTP ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};

// Convenient method wrappers
export const api = {
    get: (endpoint) => request(endpoint, { method: 'GET' }),
    post: (endpoint, body) => request(endpoint, { method: 'POST', body }),
    put: (endpoint, body) => request(endpoint, { method: 'PUT', body }),
    patch: (endpoint, body) => request(endpoint, { method: 'PATCH', body }),
    delete: (endpoint) => request(endpoint, { method: 'DELETE' }),
};

export default api;
